// frontend/src/components/PrivacyNotice.jsx
import React from 'react';

const PrivacyNotice = () => {
  return (
    <div className="text-xs text-gray-500 mb-2">
      <p>
        <strong>Privacy Notice:</strong> Your questions remain anonymous. 
        Instructors may see questions (but not who asked them) to help improve classroom discussions.
      </p>
    </div>
  );
};

export default PrivacyNotice;